export enum FormComponent {
  Input = "InputField",
  Select = "SelectField",
  DatePicker = "DatePickerField",
  Range = "RangeField",
  Checkbox = "CheckboxField",
  Textarea = "TextareaField",
  SearchableSelect = "SearchableSelect",
  RadioField = "RadioField"
}

export type FormComponentType = keyof typeof FormComponent;

export type FormFieldType =
  | 'text'
  | 'number'
  | 'email'
  | 'password'
  | 'select'
  | 'multiselect'
  | 'date'
  | 'textarea'
  | 'checkbox'
  | 'radio'
  | 'searchableSelect';

export interface FormField {
  name: string;
  label: string;
  type: FormFieldType;
  placeholder?: string;
  options?: { label: string; value: string | number }[];
  validation?: {
    required?: boolean;
    min?: number;
    max?: number;
    pattern?: string;
    message?: string;
  };
  defaultValue?: any;
}
